module.exports = __webpack_public_path__ + "img/IE-mobile-image@610.e3494e16.png";